import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { isE2EESupported } from 'livekit-client'

const useBrowserSupport = () => {
  let isBrowserSupported = true

  const isForceUnsupportedBrowserOn = useFeatureIsOn('force-unsupported-browser')
  if (isForceUnsupportedBrowserOn === true) {
    isBrowserSupported = false
  }

  if (isE2EESupported() === false) {
    isBrowserSupported = false
  }

  return {
    isBrowserSupported,
  }
}

export default useBrowserSupport
